module.exports = __webpack_public_path__ + "img/av152.99fff3cf.png";